import * as Yup from 'yup';

// Email List
const splitEmails = (emailsString: string | undefined) =>
  emailsString?.trim().replace(/\s+/g, '').split(',').filter(Boolean);

const EMAIL_LIST_SCHEMA = Yup.string().test({
  name: 'emailList',
  message: 'Please provide a valid email.',
  test: (value) => {
    const emails = splitEmails(value);
    const schema = Yup.string().email();
    return !!emails?.every((email: string) => schema.isValidSync(email));
  },
});

export { Yup, splitEmails, EMAIL_LIST_SCHEMA };
